import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import DateTime from '../../../components/DateTime';
import { onFormatDate, onFormatTime, onFormatUTCTime } from '../../../utils/dateUtils';

const Container = styled.div`
  color: ${({ theme }) => theme.player.main.color};
  text-align: center;
  padding: 8px;
`;

interface ILegendProps {}

const Legend: React.FunctionComponent<ILegendProps> = (props) => {
  return (
    <Container {...props}>
      <div>
        SYSTEM DATE: <DateTime isLive onFormat={onFormatDate} /> SYSTEM TIME:{' '}
        <DateTime isLive onFormat={onFormatUTCTime} />
      </div>
      <div>
        LOCAL DATE: <DateTime isLive onFormat={onFormatDate} /> LOCAL TIME:{' '}
        <DateTime isLive onFormat={onFormatTime} />
      </div>
    </Container>
  );
};

export default Legend;
